// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__b0xHc","footer":"ModalFilter_footer__1FIDY"};